import { supabase } from '../../../infra_/supabase/supabaseClient.js'; 


export async function vistaListarGastoXMetodo({ fechaInicio, fechaFin } = {}) {
  let query = supabase
    .from("vista_gastos_diario_metodo")
    .select("*")
    .order("fecha", { ascending: false });

  // Filtro opcional por rango de fechas
  if (fechaInicio && fechaFin) {
    query = query
      .gte("fecha", fechaInicio)
      .lte("fecha", fechaFin);
  }

  const { data, error } = await query;

  if (error) {
    console.error("[vistaGastoXMetodo.repository] Error:", error.message);
    throw new Error("No se pudo obtener el reporte de gastos por método");
  }

  return data;
}


